import LocalSeoPage from '@/pages/local/components/LocalSeoPage';
import { aracruzMecanica } from '@/mocks/localSeoData';

export default function MecanicaIndustrialAracruz() {
  return <LocalSeoPage data={aracruzMecanica} />;
}